export default __webpack_public_path__ + "static/100--stacked-bar-7671456cfa0a4987c7d6e6229bba4a22.png";